// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../@vue/cli-service/node_modules/css-loader/index.js??ref--9-oneOf-3-1!../../../../postcss-loader/src/index.js??ref--9-oneOf-3-2!../../../../postcss-loader/src/index.js??ref--9-oneOf-3-3!../../../../sass-loader/dist/cjs.js??ref--9-oneOf-3-4!./VBadge.sass");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add CSS to Shadow Root
var add = require("!../../../../vue-style-loader/lib/addStylesShadow.js").default
module.exports.__inject__ = function (shadowRoot) {
  add("b6ad06a8", content, shadowRoot)
};